import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, List, Button, Typography, Space, Spin, Modal, Badge, Empty, message } from 'antd';
import { BookOutlined, EyeOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import firebase from "../../firebase"
import { updateItemFromSellData } from "../../utils/itemSync";

const { Title, Text } = Typography;

const pad = (n) => (n > 9 ? "" + n : "0" + n);

class MobileOtasukeCartHistoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dbItems: [],
            last: null,
            itemsPerPage: 12,
            changed: false,
            searchword: '',
            cartselect: false,
            otasukeCartSelect: false,
            selectedItem: {},
            loadedAllItem: false,
            deleteModal: false,
            deleteId: null,
            deleteTitle: null,
        }
    }

    getItems = async (reset = false, word = '') => {
        if (this.state.loaded) return;
        if (this.state.loading) return;
        if (!this.props.userOrg) return;
        if (!this.props.org) return;
        if (this.state.loadedAllItem) return;

        this.setState({ loading: true });
        let first;

        const isBuyer = (this.props.userOrg && this.props.userOrg.buyer) || (this.props.userOrg && this.props.userOrg.reseller && this.props.org.maker);

        if (isBuyer) {
            first = this.props.db.collection('otasuke_carts_history')
                .where("toOrganization", "==", this.props.userOrg?.id)
                .where("fromOrganization", "==", this.props.org.id)
                .where("sendHelpCart", "==", 1)
                .orderBy('created', 'desc')
                .limit(this.state.itemsPerPage);
        } else {
            first = this.props.db.collection('otasuke_carts_history')
                .where("toOrganization", "==", this.props.org.id)
                .where("fromOrganization", "==", this.props.userOrg?.id)
                .orderBy('created', 'desc')
                .limit(this.state.itemsPerPage);
        }

        if (this.state.last && !reset) {
            first = first.startAfter(this.state.last);
        }

        let collection;
        let urigawa = false;
        if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
            collection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items')
            urigawa = true;
        } else if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
            collection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items')
        } else if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
            collection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items')
        } else if (this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
            collection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items')
            urigawa = true;
        }

        if (first && collection) {
            let och = await first.get()
            if (och.docs.length > 0) {
                let last = och.docs[och.docs.length - 1];
                this.setState({ last: last })

                let items = this.state.dbItems;
                if (reset) {
                    items = [];
                }

                for (let i = 0; i < och.docs.length; i++) {
                    let doc = och.docs[i];
                    let data = doc.data();
                    data.id = doc.id;

                    let cart = data.cart;
                    delete cart['deletedItem'];
                    delete cart['deletedText'];
                    await Promise.all(cart.items.map(async (item, index) => {
                        let itemSell = await collection.doc(item.id).get();
                        let itemSellData = itemSell.data();

                        delete item['deletedItem'];
                        delete item['deletedText'];

                        if (!itemSellData) {
                            cart.deletedItem = true;
                            item.deletedItem = true;
                            item.deletedText = '販売終了商品が含まれています';
                            cart.deletedText = '販売終了商品が含まれています';
                        } else if ((itemSellData && !itemSellData['price']) || (itemSellData && itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                            cart.deletedItem = true;
                            item.deletedItem = true;
                            item.deletedText = '要見積商品が含まれています';
                            cart.deletedText = '要見積商品が含まれています';
                        } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                            cart.deletedItem = true;
                            item.deletedItem = true;
                            item.deletedText = '要見積商品が含まれています';
                            cart.deletedText = '要見積商品が含まれています';
                        } else if (itemSellData && itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                            let expiration_date = itemSellData['price'][0]['expiration_date'];
                            let expDate = expiration_date.toDate();

                            if ((expDate.getTime() - this.props.dateNow) < 0) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                if (!urigawa) {
                                    cart.deletedText = '価格有効期限切れ要見積が含まれています';
                                    item.deletedText = '価格有効期限切れ要見積が含まれています';
                                } else {
                                    cart.deletedText = '要見積商品が含まれています';
                                    item.deletedText = '要見積商品が含まれています';
                                }
                            } else {
                                if (!urigawa) {
                                    item.price = itemSellData['price'][0]['price'];
                                }
                            }
                        } else {
                            if (!urigawa) {
                                item.price = itemSellData['price'][0]['price'];
                            }
                        }

                        if (!item.deletedItem) {
                            updateItemFromSellData(item, itemSellData, urigawa);
                        }
                    }));

                    items.push(data)
                }
                this.setState({ dbItems: items })
            } else {
                this.setState({ loadedAllItem: true });
            }
            this.setState({ loading: false });
        }
        else {
            this.setState({ loading: false })
        }
    }

    componentDidMount() {
        this.getItems();
        window.addEventListener('scroll', this.watchCurrentPosition, true);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.org !== nextProps.org || this.props.userOrg !== nextProps.userOrg) {
            this.setState({ changed: true })
        }
    }

    componentDidUpdate() {
        if (this.state.changed) {
            this.setState({
                changed: false,
                loadedAllItem: false,
                dbItems: [],
                last: null
            }, () => {
                this.getItems(true);
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.watchCurrentPosition, true);
    }

    watchCurrentPosition = () => {
        if (window.innerHeight + this.scrollTop() + 50 >= document.body.clientHeight) {
            this.onReachEnd();
        }
    }

    scrollTop = () => {
        return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    }

    onReachEnd = () => {
        this.getItems(false, this.state.searchword);
    }

    modalDelClose = () => {
        this.setState({ deleteModal: false, deleteId: null, deleteTitle: null })
    }

    deleteHelpCart = (id, title) => {
        this.setState({ deleteId: id, deleteTitle: title, deleteModal: true })
    }

    confirmDelete = () => {
        if (this.state.deleteId) {
            const self = this;
            const otasukeCartHistoryRef = this.props.db.collection('otasuke_carts_history').doc(this.state.deleteId);
            otasukeCartHistoryRef.set({ sendHelpCart: 2 }, { merge: true })
                .then(function () {
                    message.success("お助けカートを削除しました。");
                    self.setState({ last: null, loadedAllItem: false, deleteModal: false, dbItems: [] }, () => {
                        self.getItems(true);
                    })
                })
                .catch(function (error) {
                    message.error("削除中にエラーが発生しました。");
                });
        }
    }

    showOtasukeDetail = (id) => {
        const otasukeRef = this.props.db.collection('otasuke_carts_history').doc(id);
        otasukeRef.set({ readBuyer: true }, { merge: true });
        this.props.readOtasuke(1);
        this.props.cProps.history.push("/otasuke/cart/detail/" + id);
    }

    render() {
        if (!this.props.org) {
            return <div style={{ padding: 24, textAlign: 'center' }}><Text type="secondary">取引先を選択してください。</Text></div>;
        }

        const isBuyer = (this.props.userOrg && this.props.userOrg.buyer) || (this.props.userOrg && this.props.userOrg.reseller && this.props.org.maker);
        const titleText = isBuyer ? "お助けカート一覧" : "お助けカート送信履歴";

        // Map list items
        const listData = this.state.dbItems.map((item, index) => {
            let amount = 0;
            let amountsFormatted = '-';

            item.cart.items.forEach((it) => {
                if (!it.deletedItem) {
                    amount += ((it.price || 0) * (it.count || 0));
                }
            });

            if (amount > 0) amountsFormatted = '¥' + amount.toLocaleString();

            return {
                id: item.id,
                cartName: item.cart?.cartName || "名称未設定",
                amount: amountsFormatted,
                index: index + 1
            };
        });

        return (
            <div style={{ padding: '8px 12px', paddingBottom: 60, background: '#f5f5f5', minHeight: '100vh' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 4px 8px', marginBottom: 8 }}>
                    <BookOutlined style={{ fontSize: 22, color: '#1677ff' }} />
                    <Title level={5} style={{ margin: 0 }}>{titleText}</Title>
                </div>

                {this.state.loading && listData.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 40 }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} spin />} />
                    </div>
                ) : listData.length === 0 ? (
                    <Empty description="お助けカートがありません" style={{ marginTop: 60 }} />
                ) : (
                    <List
                        dataSource={listData}
                        renderItem={(row) => (
                            <Card
                                key={row.id}
                                style={{ marginBottom: 12, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.07)' }}
                                bodyStyle={{ padding: '14px 16px' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <Space>
                                        <Badge count={pad(row.index)} style={{ backgroundColor: '#1677ff' }} />
                                        <Text strong style={{ fontSize: 16 }}>{row.cartName}</Text>
                                    </Space>
                                </div>
                                
                                <div style={{ marginBottom: 12, textAlign: 'left', marginLeft: 34 }}>
                                    <Text type="secondary" style={{ fontSize: 13 }}>合計金額: </Text>
                                    <Text strong style={{ color: '#d32f2f' }}>{row.amount}</Text>
                                </div>

                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Button
                                        type="primary"
                                        icon={<EyeOutlined />}
                                        style={{ flex: 1 }}
                                        onClick={() => this.showOtasukeDetail(row.id)}
                                    >
                                        表示
                                    </Button>
                                    {isBuyer && (
                                        <Button
                                            danger
                                            icon={<DeleteOutlined />}
                                            style={{ flex: 1 }}
                                            onClick={() => this.deleteHelpCart(row.id, row.cartName)}
                                        >
                                            削除
                                        </Button>
                                    )}
                                </div>
                            </Card>
                        )}
                    />
                )}

                {this.state.loading && listData.length > 0 && (
                    <div style={{ textAlign: 'center', padding: 10 }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                    </div>
                )}

                <Modal
                    title="お助けカート削除"
                    visible={this.state.deleteModal}
                    onCancel={this.modalDelClose}
                    footer={[
                        <Button key="cancel" onClick={this.modalDelClose}>キャンセル</Button>,
                        <Button key="delete" type="primary" danger onClick={this.confirmDelete}>OK</Button>
                    ]}
                >
                    <p>お助けカート「{this.state.deleteTitle}」を削除します。 よろしいですか？</p>
                </Modal>

            </div>
        );
    }
}

export default MobileOtasukeCartHistoryList;
